import { Linking, Platform } from 'react-native'
import { newsAppRoute, safeNewsUrl } from '@warcarp/api-types'
import { reportError } from './reporting'

/** Admin previews omit navigate: game URLs must never enter the admin router. */
export function openNewsLink(href: string, navigate?: (path: string) => void): void {
  if (!safeNewsUrl(href)) return
  const path = newsAppRoute(href)
  if (path && navigate) { navigate(path); return }
  if (Platform.OS === 'web') { window.open(href, '_blank', 'noopener,noreferrer'); return }
  void Linking.openURL(href).catch(error => reportError(error, { tags: { area: 'news-link' }, extra: { href } }))
}
